import DropdownMenu, { DropdownItem } from '@atlaskit/dropdown-menu';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../../messages/sign-up-form';
import { GetAccountOrgsResponse } from '@atlassiansox/asc-stargate';
import {
  DropdownTrigger,
  OrganizationDropdownContainer,
  OrganizationDropdownButtonStyle,
  OrganizationDropdownButtonStyleOpen,
  OrganizationDropdownTextContainer,
  OrganizationDropdownItemContainer,
  OrgPickerElementMargin,
  FieldLabel
} from './styled';
import { AccountOrg, VortexStatus } from '../../utility';

type OnOpenChangeProps = {
  readonly isOpen: boolean;
  readonly isDisabled: boolean;
  readonly event?: { [key: string]: any };
};

type BitbucketOrganizationPickerProps = {
  orgList: GetAccountOrgsResponse;
  selectedOrg: AccountOrg | null;
  setSelectedOrg: (org: AccountOrg) => void;
};

export function shouldRenderBitbucketOrgPicker(
  orgAdminVortexStatusCounts: Record<VortexStatus, number>
) {
  if (
    orgAdminVortexStatusCounts.ENABLED === 1 &&
    orgAdminVortexStatusCounts.DISABLED === 0
  ) {
    return false;
  }
  return orgAdminVortexStatusCounts.ENABLED > 0;
}

export function BitbucketOrganizationPicker({
  orgList,
  selectedOrg,
  setSelectedOrg
}: BitbucketOrganizationPickerProps) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const trigger = (
    <DropdownTrigger>
      <OrganizationDropdownTextContainer>
        {selectedOrg ? (
          selectedOrg.name
        ) : (
          <FormattedMessage {...messages.selectOrganization} />
        )}
      </OrganizationDropdownTextContainer>
    </DropdownTrigger>
  );

  const triggerButtonTheme = () => {
    const buttonStyles = !isDropdownOpen
      ? OrganizationDropdownButtonStyle
      : Object.assign(
          {},
          OrganizationDropdownButtonStyle,
          OrganizationDropdownButtonStyleOpen
        );
    return {
      buttonStyles,
      spinnerStyles: {}
    };
  };

  return (
    <OrgPickerElementMargin>
      <FieldLabel>
        <FormattedMessage
          {...messages.bitbucketOrganizationIdFieldLabelMessage}
        />
      </FieldLabel>
      <OrganizationDropdownContainer>
        <DropdownMenu
          trigger={trigger}
          triggerType="button"
          shouldFitContainer={true}
          triggerButtonProps={{
            shouldFitContainer: true,
            theme: triggerButtonTheme
          }}
          onOpenChange={({ isOpen }: OnOpenChangeProps) =>
            setIsDropdownOpen(isOpen)
          }
        >
          {orgList
            .filter((item) => item.vortexMode === VortexStatus.ENABLED)
            .map((item) => (
              <DropdownItem key={item.id} onClick={() => setSelectedOrg(item)}>
                <OrganizationDropdownItemContainer>
                  {item.name}
                </OrganizationDropdownItemContainer>
              </DropdownItem>
            ))}
        </DropdownMenu>
      </OrganizationDropdownContainer>
    </OrgPickerElementMargin>
  );
}
